import React from "react";
import { Box, Typography, IconButton, Tabs, Tab } from "@mui/material";
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from "@mui/material";
import Close from "@mui/icons-material/Close";
const CodeListSection = ({
  selectedCodes,
  handleDelete,
  readOnly = false,
  dxCodes = null,
}) => {
  const [tabValue, settabValue] = React.useState(0);
  const handleTabChange = (event, newValue) => {
    settabValue(newValue);
  };

  // Existing code list rendering
  const list = (
    <Box sx={{ width: "100%" }}>
      {/* {readOnly && diagnosisTabs} */}

      <List dense>
        {selectedCodes.map((item, index) => (
          <ListItem key={index}>
            <ListItemText
              primary={
                item.description
                  ? `${item.code} - ${item.description}`
                  : `${item.code}`
              }
            />

            {handleDelete && !readOnly && (
              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  aria-label="delete"
                  onClick={() => handleDelete(index)}
                >
                  <Close />
                </IconButton>
              </ListItemSecondaryAction>
            )}
          </ListItem>
        ))}
      </List>
    </Box>
  );

  if (readOnly && !selectedCodes.length) {
    return "No codes to display.";
  }

  const tabs = (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={tabValue} onChange={handleTabChange} variant="fullWidth">
          <Tab label="Condensed" />
          <Tab label="Expanded" />
        </Tabs>
      </Box>
      {tabValue === 1 && list}
      {tabValue === 0 && (
        <List dense>
          {dxCodes?.dxCodesCondensed?.split(",").map((item, index) => (
            <ListItem key={index}>
              <ListItemText>{item}</ListItemText>
            </ListItem>
          ))}
        </List>
      )}
    </>
  );

  return (
    <Box mt={2}>
      {!readOnly && (
        <Typography sx={{ fontWeight: "bold" }} gutterBottom>
          Code List
        </Typography>
      )}
      {readOnly ? (
        dxCodes ? (
          tabs
        ) : (
          list
        )
      ) : (
        <Box
          sx={{ border: "1px solid black", height: "130px", overflowY: "auto" }}
        >
          {list}
        </Box>
      )}
    </Box>
  );
};

export default CodeListSection;
